import React, {useMemo} from 'react';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import isEmpty from "is-empty";
import {getProperty} from "@/Helpers/Function";

export default function FilterLayoutDoubleRadioChildren(props) {
    const {stores = {}, storeName = '', parent = '', child = '',} = props;
    if (isEmpty(storeName) || isEmpty(parent) || isEmpty(child)) return null;
    const {filterStore = {}} = stores;

    // Разбиваем url в массив
    const assign = Object.assign([], filterStore[storeName]);

    const dataOne = useMemo(() => {
        return assign.sort((a, b) => {
            if (a[`${parent}`].sort < b[`${parent}`].sort) return -1;
            if (a[`${parent}`].sort > b[`${parent}`].sort) return 1;
            return 0;
        });
    }, [filterStore[storeName], assign]);

    return dataOne.map((el) => {
        return (
            <div key={el[`${parent}`].id} className={`dropdown-filter__listCategory`}>
                <FormControlLabel
                    control={
                        <Radio
                            color={`default`}
                            disabled={!filterStore[`${storeName}Control`].includes(el[`${parent}`].valueAlias)}
                            checked={!!filterStore.urlDynamic.split('/').includes(el[`${parent}`].valueAlias)}
                            value={el[`${parent}`].valueAlias}
                            onClick={() => {
                                if (filterStore.allChips.some((Chip) => Chip.valueAlias === el[`${parent}`].valueAlias)) {
                                    filterStore.handleDeleteChips(parent, el[`${parent}`].valueAlias);
                                } else {
                                    filterStore.activePage = 1;
                                    filterStore.catalogListShowCount = filterStore.catalogListShowStart;
                                    filterStore[`${parent}FilterRadio`] = el[`${parent}`].valueAlias + '/';
                                    filterStore[`${child}FilterRadio`] = '';
                                }
                                filterStore.catalogSend();
                                filterStore.loaderFilter = true
                            }}
                        />
                    }
                    label={el[`${parent}`].value}
                />
                {
                    getProperty(el, child, []).sort((a, b) => {
                        if (a.sort < b.sort) return -1;
                        if (a.sort > b.sort) return 1;
                        return 0;
                    }).map((elChild) => {
                        return <div key={elChild.id} className={`filter__list_subcategory`}>
                            <FormControlLabel
                                control={
                                    <Radio
                                        color={`default`}
                                        disabled={!filterStore[`${child}Control`].includes(elChild.valueAlias)}
                                        checked={!!filterStore.urlDynamic.split('/').includes(elChild.valueAlias)}
                                        value={elChild.valueAlias}
                                        onClick={() => {
                                            if (filterStore.allChips.some((Chip) => Chip.valueAlias === elChild.valueAlias)) {
                                                filterStore.handleDeleteChips(child, elChild.valueAlias);
                                            } else {
                                                filterStore[`${parent}FilterRadio`] = el[`${parent}`].valueAlias + '/';
                                                filterStore[`${child}FilterRadio`] = elChild.valueAlias + '/';
                                                filterStore.activePage = 1;
                                                filterStore.catalogListShowCount = filterStore.catalogListShowStart;
                                            }
                                            filterStore.catalogSend();
                                            filterStore.loaderFilter = true
                                        }}
                                    />
                                }
                                label={elChild.value}
                            />
                        </div>
                    })
                }
            </div>
        );
    });
}
